
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-Teams");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/Teams/index.js
// module id = Hmsr
// module chunks = 12